//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import Field from '../../common/Field'
import Validator from '../../common/Validator'
import Reflux from 'reflux'
import Store from '../../../store/store'
import DatePicker from 'react-date-picker';
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import api from '../../../source/api'
import 'moment/locale/hu'
import NotificationSystem from 'react-notification-system'
import i18 from '../../../i18'
import actions from '../../../actions/actions'
import {Link} from "react-router-dom";

const STEPS_COUNT = 2

class Upload extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            processing: false,
            userconfigs: {},
            company_id: props.location.match.params.id,
            step: props.currentStep,
            fields: {
                cashregister_ledger_number: {value: '', error: '', role: {required: true}},
                technical_number_of_bankcard_payment: {value: '', error: '', role: {required: true}},
                ledger_number_of_price_income: {value: '', error: '', role: {required: true}},
                ledger_number_of_vat_free_sales: {value: '', error: '', role: {required: true}},
                ledger_number_of_five_percent_vat_sales: {value: '', error: '', role: {required: true}},
                ledger_number_of_eighteen_percent_vat_sales: {value: '', error: '', role: {required: true}},
                ledger_number_of_twentyseven_percent_vat_sales: {value: '', error: '', role: {required: true}},
                job_number: {value: '', error: '', role: {required: false}},
                job_number_name: {value: '', error: '', role: {required: false}},
                zipFiles: {value: '', error: '', role: {required: true}},
            },
            startDate: new Date(),
            endDate: new Date(),
            company: props.company,
        }
        this.store = Store
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        let fields = this.state.fields;
        let startDate = new Date();
        let endDate = new Date();

        if (nextProps.userconfigs && Object.keys(nextProps.userconfigs).length > 0) {
            fields.cashregister_ledger_number.value = nextProps.userconfigs.cashregister_ledger_number
            fields.technical_number_of_bankcard_payment.value = nextProps.userconfigs.technical_number_of_bankcard_payment
            fields.ledger_number_of_price_income.value = nextProps.userconfigs.ledger_number_of_price_income
            fields.ledger_number_of_vat_free_sales.value = nextProps.userconfigs.ledger_number_of_vat_free_sales
            fields.ledger_number_of_five_percent_vat_sales.value = nextProps.userconfigs.ledger_number_of_five_percent_vat_sales
            fields.ledger_number_of_eighteen_percent_vat_sales.value = nextProps.userconfigs.ledger_number_of_eighteen_percent_vat_sales
            fields.ledger_number_of_twentyseven_percent_vat_sales.value = nextProps.userconfigs.ledger_number_of_twentyseven_percent_vat_sales
            fields.job_number.value = nextProps.userconfigs.job_number
            fields.job_number_name.value = nextProps.userconfigs.job_number_name

            startDate = new Date(nextProps.userconfigs.start_date);
            endDate = new Date(nextProps.userconfigs.end_date);
        }

        this.setState({
            fields: fields,
            userconfigs: nextProps.userconfigs,
            company: nextProps.company,
            startDate: startDate,
            endDate: endDate,
        })
    }

    componentDidMount = () => {
        moment.locale('hu')
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)
    }

    startDataProcessing = () => {
        const form = this.buildSubmitForm()
        document.body.classList.toggle('loading-body', true)
        api.postFile({url: 'cashregister/steps/upload', data: form}, true).then((response) => {
            this.setState({processing: false})
            this.props.setOutputFiles(response.data)
            if (this.state.step > STEPS_COUNT) {
                return
            }
            this.props.setNextStep()
            this.setState({step: this.state.step + 1});
            document.body.classList.remove('loading-body')
        }).catch((err) => {
            document.body.classList.remove('loading-body')
            this.setState({processing: false})
            this._addNotification('Kérjük ellerőrizze a könyvelt időszakot és a bementi fájl kiterjesztését és méretét.', 'error', 30)
        })
    }

    buildSubmitForm = () => {
        let form = new FormData()
        let inputFile = document.querySelector('#zipFiles')
        form.append('zipFiles', inputFile.files[0])
        form.append('startDate', moment(this.state.startDate).format('YYYY-MM-DD'))
        form.append('endDate', moment(this.state.endDate).format('YYYY-MM-DD'))
        form.append('company_id', this.state.company_id)
        form.append('cashregister_ledger_number', this.state.fields.cashregister_ledger_number.value)
        form.append('technical_number_of_bankcard_payment', this.state.fields.technical_number_of_bankcard_payment.value)
        form.append('ledger_number_of_price_income', this.state.fields.ledger_number_of_price_income.value)
        form.append('job_number', this.state.fields.job_number.value)
        form.append('job_number_name', this.state.fields.job_number_name.value)
        form.append('ledger_number_of_vat_free_sales', this.state.fields.ledger_number_of_vat_free_sales.value)
        form.append('ledger_number_of_five_percent_vat_sales', this.state.fields.ledger_number_of_five_percent_vat_sales.value)
        form.append('ledger_number_of_eighteen_percent_vat_sales', this.state.fields.ledger_number_of_eighteen_percent_vat_sales.value)
        form.append('ledger_number_of_twentyseven_percent_vat_sales', this.state.fields.ledger_number_of_twentyseven_percent_vat_sales.value)
        return form
    }

    handleStartDateChange = (date) => {
        this.setState({
            startDate: date
        });
    }

    handleEndDateChange = (date) => {
        this.setState({
            endDate: date
        });
    }
    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    nextStep = () => {
        let validator = Validator.validate(this.state.fields)
        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
            })
            return;
        }

        this.setState({processing: true});
        this.startDataProcessing()
    }

    render() {
        return (
            <div className='col-10 offset-1'>
                <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : ''} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                <br/>
                <div className='row'>
                    <div className='col-md-3'>
                        <p> Könyvelt időszak:</p>
                    </div>
                    <div className='col-md-3'>
                        <DatePicker
                            className="date-picker"
                            required={true}
                            locale="hu-HU"
                            onChange={this.handleStartDateChange}
                            value={this.state.startDate}
                        />
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-md-3'>
                        <DatePicker
                            className="date-picker"
                            locale="hu-HU"
                            onChange={this.handleEndDateChange}
                            value={this.state.endDate}
                        />
                    </div>
                </div>

                <table className='table table-striped  table-aibook-bordered'>
                    <tbody>
                    <tr>
                        <td>Pénztár főkönyvi száma *</td>
                        <td>
                            <Field
                                type='text'
                                id='cashregister_ledger_number'
                                name='cashregister_ledger_number'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Bankkártyafizetés technikai főkönyvi száma *</td>
                        <td>
                            <Field
                                type='text'
                                id='technical_number_of_bankcard_payment'
                                name='technical_number_of_bankcard_payment'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Árbevtelkarton főkönyvi száma *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_price_income'
                                name='ledger_number_of_price_income'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 0% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_vat_free_sales'
                                name='ledger_number_of_vat_free_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 5% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_five_percent_vat_sales'
                                name='ledger_number_of_five_percent_vat_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 18% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_eighteen_percent_vat_sales'
                                name='ledger_number_of_eighteen_percent_vat_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Fizetendő áfa főkönyvi száma 27% értékesítés esetén *</td>
                        <td>
                            <Field
                                type='text'
                                id='ledger_number_of_twentyseven_percent_vat_sales'
                                name='ledger_number_of_twentyseven_percent_vat_sales'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Munkaszám</td>
                        <td>
                            <Field
                                type='text'
                                id='job_number'
                                name='job_number'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    {this.state.company && this.state.company.accountant_program_id === 1
                        ? <tr>
                            <td>Munkaszám neve</td>
                            <td>
                                <Field
                                    type='text'
                                    id='job_number_name'
                                    name='job_number_name'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        : null
                    }
                    </tbody>
                </table>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <Field
                            type='file'
                            id='zipFiles'
                            name='zipFiles'
                            label='Pénztárgép ZIP'
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <br/>
                        <div className='next-step-btn-container'>
                            <a onClick={() => this.nextStep()} className={this.state.processing ? 'disabled next-step' : 'next-step'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._startProcessing}</a>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </div>
        )
    }
}

export default Upload


// WEBPACK FOOTER //
// ./src/components/cashregister/steps/upload.js